import ApiServiceWrapper from '@/shared/api-request.service';
const endpointPrefixUsers = 'users/';
const affiliationsApi = {
  getAffiliationList() {
    const reqEndPoint = 'users/get-affiliation';
    return ApiServiceWrapper.get<any>(reqEndPoint);
  },
  getOrgInfoForAffiliaction(val: any) {
    const paylaod = {
      orgIdentifier: val,
    };
    const reqEndPoint = `${endpointPrefixUsers}get-org-info`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, paylaod);
  },
  addAffiliation(payload: any) {
    const reqEndPoint = `${endpointPrefixUsers}add-affiliation`;
    console.warn(reqEndPoint, payload);
    return ApiServiceWrapper.post(`${reqEndPoint}`, payload);
  },
  getUsersForAffiliation() {
    const reqEndPoint = `${endpointPrefixUsers}list-users-for-affiliation`;
    return ApiServiceWrapper.get(`${reqEndPoint}`);
  },
  reviewAffiliation(payload: any) {
    const reqEndPoint = `${endpointPrefixUsers}review-affiliation`;
    return ApiServiceWrapper.post(`${reqEndPoint}`, payload);
  },
};

export default affiliationsApi;
